var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                action: "",
                "http-request": _vm.handleUploadForm,
                "on-change": _vm.imgSaveToUrl,
                headers: _vm.myHeaders,
                "show-file-list": false,
                multiple: "",
              },
            },
            [
              _vm.pictureType
                ? _c(
                    "el-button",
                    { staticClass: "mr10", attrs: { type: "primary" } },
                    [_vm._v("上传文件")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }